import * as Sentry from '@sentry/react';

import {
  darkActions,
  darkBackground,
  darkError,
  darkPrimary,
  darkSuccess,
  darkText,
  lightActions,
  lightBackground,
  lightError,
  lightPrimary,
  lightSuccess,
  lightText,
} from './colors';

Sentry.init({
  enabled: import.meta.env.PROD,
  environment: import.meta.env.PROD ? 'production' : 'development',
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      autoInject: false,
      showBranding: false,
      themeLight: {
        foreground: lightText.primary,
        background: lightBackground.paper,
        accentForeground: lightPrimary.contrast,
        accentBackground: lightPrimary.dark,
        successColor: lightSuccess.main,
        errorColor: lightError.main,
        boxShadow: '0px 4px 24px 0px rgba(9, 30, 66, 0.12)',
        outline: `1px auto ${lightActions.focus}`,
      },
      themeDark: {
        foreground: darkText.primary,
        background: darkBackground.paper,
        accentForeground: darkPrimary.contrast,
        accentBackground: darkPrimary.main,
        successColor: darkSuccess.main,
        errorColor: darkError.main,
        boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.32)',
        outline: `1px auto ${darkActions.focus}`,
      },
    }),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/single-building-app-api.signalos\.app/,
    /^https:\/\/single-building-app-meili.signalos\.app/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
